// extracted by mini-css-extract-plugin
export default {"exercises":"index_exercises__-MoD+"};